<script>
import { onSnapshot, collection, updateDoc, doc } from 'firebase/firestore';
import { fly } from 'svelte/transition';
import { db } from './firebase.js'; 

export let uid;

let notificationQueue = [];
let currentNotification = null;
let currentNotificationId = null;
let showNotification = false;

const notificationsCollection = collection(db, "notifications", uid, "userNotifications");

const unsubscribe = onSnapshot(notificationsCollection, async (querySnapshot) => {
    querySnapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
            const data = change.doc.data();
            const minutesDifference = (new Date().getTime() - data.timestamp.toDate().getTime()) / (1000 * 60);
            
            if (data.isFresh && minutesDifference < 2) {
                notificationQueue.push({ id: change.doc.id, content: data.content });
                processQueue();
            }
        }
    });
});

async function processQueue() {
    if (currentNotification === null && notificationQueue.length > 0) {
        const nextNotification = notificationQueue.shift();
        currentNotification = nextNotification.content;
        currentNotificationId = nextNotification.id;
        
        showNotification = true;
        await markAsViewed();

        setTimeout(() => {
            showNotification = false;
            currentNotification = null;
            currentNotificationId = null;
            if (notificationQueue.length > 0) {
                processQueue();
            }
        }, 5000);
    }
}

async function markAsViewed() {
    const notificationDoc = doc(db, "notifications", uid, "userNotifications", currentNotificationId);
    await updateDoc(notificationDoc, {
        isFresh: false
    });
}

function tempNotif() {
    if (!localStorage.getItem('notif_cust2')) {
        currentNotification = "Create custom personas with the Custom button underneath Friend/Flirty."
        showNotification = true;
        localStorage.setItem('notif_cust2', 'true');

         setTimeout(() => {
            showNotification = false;
            currentNotification = null;
            
        }, 6000);
    }
}
setTimeout(() => {
    tempNotif();
}, 1000);

</script>

{#if showNotification}
<div 
    transition:fly="{{ y: -100, duration: 300 }}"
    class="fixed top-0 left-0 right-0 bg-blue-500 text-white p-4 z-50"
>
    {currentNotification}
</div>
{/if}

